import { useNavigate } from 'react-router-dom';

export default function Terms() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-gray-100">
        <div className="w-full px-4 md:px-8 lg:px-12 py-4">
          <div className="max-w-4xl mx-auto flex items-center justify-between">
            <button onClick={() => navigate('/')} className="text-xl font-bold text-navy-600 cursor-pointer">
              EzyAbroad
            </button>
            <button
              onClick={() => navigate('/')}
              className="text-sm text-gray-500 hover:text-navy-600 cursor-pointer"
            >
              ← Back to Home
            </button>
          </div>
        </div>
      </header>

      <main className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-4xl font-bold text-navy-600">Terms of Service</h1>
          <p className="mt-2 text-sm text-gray-400">Last updated: April 27, 2025</p>

          <div className="mt-10 space-y-8 text-gray-600 leading-relaxed">
            <section>
              <h2 className="text-xl font-semibold text-navy-600 mb-3">1. Acceptance of Terms</h2>
              <p>
                By accessing or using EzyAbroad&apos;s website, mobile application, and services (collectively, the &ldquo;Services&rdquo;), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our Services.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-navy-600 mb-3">2. Description of Services</h2>
              <p>
                EzyAbroad is a study abroad platform that connects students with education consultancies. We provide tools for appointment booking, AI-powered guidance, CRM management, and lead tracking. We do not guarantee university admissions or visa approvals.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-navy-600 mb-3">3. User Accounts</h2>
              <p className="mb-3">
                To access certain features, you must create an account. You agree to:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Provide accurate and complete information</li>
                <li>Maintain the security of your account credentials</li>
                <li>Notify us immediately of any unauthorized access</li>
                <li>Accept responsibility for all activities under your account</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-navy-600 mb-3">4. Consultancy Responsibilities</h2>
              <p className="mb-3">
                Education consultancies using our platform agree to:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Provide accurate information about their services</li>
                <li>Respond to student enquiries in a timely manner</li>
                <li>Comply with all applicable laws and regulations</li>
                <li>Maintain professional standards in all interactions</li>
                <li>Not use the platform for fraudulent or misleading purposes</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-navy-600 mb-3">5. Payment and Billing</h2>
              <p>
                Consultancy subscription plans are billed monthly or annually as selected. All fees are exclusive of applicable taxes. We reserve the right to change pricing with 30 days notice. Refunds are provided at our discretion.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-navy-600 mb-3">6. Intellectual Property</h2>
              <p>
                All content, trademarks, logos, and software on EzyAbroad are the property of EzyAbroad Technologies Pvt. Ltd. or its licensors. You may not copy, modify, distribute, or create derivative works without our express permission.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-navy-600 mb-3">7. Limitation of Liability</h2>
              <p>
                EzyAbroad is not liable for any indirect, incidental, special, or consequential damages arising from your use of our Services. Our total liability shall not exceed the amount you paid us in the 12 months preceding the claim.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-navy-600 mb-3">8. Governing Law</h2>
              <p>
                These Terms shall be governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts in Hyderabad, Telangana.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-navy-600 mb-3">9. Contact</h2>
              <p>
                For questions about these Terms, contact us at{" "}
                <a href="mailto:hello@ezyabroad.com" className="text-gold-600 hover:text-gold-500">hello@ezyabroad.com</a>.
              </p>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
}
